<div class="validation-error {{ styleModificators }}" *ngIf="isDisplayed()">
  <div class="error-message error-message_color_alert">
    <div *ngFor="let errorCode of getErrorCodes()">
      {{ constructTranslateKey(errorCode) | translate: { value: getErrorValue(errorCode) } }}
    </div>
  </div>
</div>
